export default {
    baseComponents: {
        basePagination: {
            previous: 'Zurück',
            next: 'Nächste',
            metaInfo: `
            Zeige <span class="font-medium">{itemsFrom}</span>
            bis <span class="font-medium">{itemsTo}</span>
            von <span class="font-medium">{itemsTotal}</span>
            Ergebnissen`,
            pageSize: 'Ergebnisse pro Seite',
        },
        baseDrawer: {
            maximize: 'Maximieren',
            minimize: 'Minimieren',
        },
    },
    general: {
        period: 'Zeitraum',
        from: 'Von',
        to: 'Bis',
        contractStart: 'Vertragsbeginn',
        day: 'Tag | Tage',
        today: 'Heute',
        week: '{count} Woche | {count} Wochen',
        hour: '{count} Stunde | {count} Stunden',
        days: '{count} Tag | {count} Tage',
        month: '{count} Monat | {count} Monate',
        custom: 'Individuell',
        noData: 'Noch keine Daten vorhanden',
        isSelfManaged: 'Selbstverwaltet',
        general: 'Allgemein ',
        services: 'Services',
        base: 'Basis',
        kilowattHour: 'Kilowattstunde | Kilowattstunden',
        all: 'Alle',
        watts: 'W',
        noResultsFound: 'Keine Ergebnisse gefunden',
        noResultsFoundDescription: 'Setzen Sie Ihre Filter zurück und versuchen Sie es erneut.',
        inclusive: 'inklusive',
        cpu: 'CPU | CPUs',
        diffInSeconds: 'Vor {count} Sekunde | Vor {count} Sekunden',
        diffInMinutes: 'Vor {count} Minute | Vor {count} Minuten',
        diffInHours: 'Vor {count} Stunde | Vor {count} Stunden',
        diffInDays: 'Vor {count} Tag | Vor {count} Tagen',
        diffInWeeks: 'Vor {count} Woche | Vor {count} Wochen',
        diffInMonths: 'Vor {count} Monat | Vor {count} Monaten',
        timezones: {
            cet: 'MEZ',
            cest: 'MESZ',
            currentGerman: '({timeZone} [{utcDifference}])',
        },
        mbps: 'Mbps',
        updatingData: 'Daten werden geladen',
        termsAndPrivacy:
            'Es gelten unsere <a class="text-blue-700 hover:text-blue-600 cursor-pointer underline" href="{termsUrl}" target="_blank">Allgemeinen Geschäftsbedingungen</a>. Bitte beachten Sie unsere <a class="text-blue-700 hover:text-blue-600 cursor-pointer underline" href="{privacyUrl}" target="_blank">Datenschutzerklärung</a>.',
        startAt: 'Beginnt am {date}',
        endAt: 'Endet am {date}',
        phone: 'Telefon',
        mail: 'Mail',
        new: 'Neu',
        status: 'Status',
    },
    actions: {
        addEntry: 'Eintrag hinzufügen',
        addFile: 'Datei hinzufügen',
        add: 'Hinzufügen',
        create: 'Anlegen',
        show: 'Anzeigen',
        showAll: 'Alle anzeigen',
        destroy: 'Löschen',
        copy: 'Kopieren',
        edit: 'Bearbeiten',
        download: 'Download',
        confirm: 'Bestätigen',
        cancel: 'Abbrechen',
        canceling: 'Wird abgebrochen...',
        save: 'Speichern',
        back: 'Zurück',
        next: 'Weiter',
        complete: 'Abschließen',
        adjust: 'Anpassen',
        logout: 'Abmelden',
        backToLogin: 'Zurück zum Login',
        editResource: '{resource} bearbeiten',
        createResource: '{resource} anlegen',
        feedback: 'Feedback',
        support: 'Support',
        deactivate: 'Deaktivieren',
        activate: 'Aktivieren',
        moreInfo: 'Mehr Infos',
        clearFilters: 'Filter zurücksetzen',
        comment: 'Kommentieren',
        contactSupport: 'Support kontaktieren',
        pay: 'Bezahlen',
        payNow: 'Jetzt bezahlen',
        editPassword: 'Passwort bearbeiten',
        turnOn: 'Einschalten',
        turnOff: 'Ausschalten',
        remove: 'Entfernen',
        goToTicket: 'Zum Ticket',
        csvExport: 'CSV-Export',
    },
    common: {
        loading: 'Lädt...',
        pay: 'Zahlen',
        close: 'Schließen',
        retry: 'Wiederholen',
        cancel: 'Abbrechen',
    },
    payment: {
        intentCreated: 'Zahlungsabsicht erfolgreich erstellt',
        intentCreationFailed: 'Fehler beim Erstellen der Zahlungsabsicht',
        paymentSuccessful: 'Zahlung erfolgreich abgeschlossen',
        paymentFailed: 'Zahlung fehlgeschlagen',
        paymentCancelled: 'Zahlung abgebrochen',
        processingPayment: 'Zahlung wird verarbeitet...',
        payInvoice: 'Rechnung bezahlen',
        invoiceNumber: 'Rechnungsnummer',
        billingInformation: 'Rechnungsinformationen',
        paymentMethod: 'Zahlungsmethode',
        fullName: 'Vollständiger Name',
        fullNamePlaceholder: 'Geben Sie Ihren vollständigen Namen ein',
        email: 'Mail',
        emailPlaceholder: 'Geben Sie Ihre Mail-Adresse ein',
        payNow: 'Jetzt bezahlen',
        paymentSuccessfulMessage: 'Ihre Zahlung wurde erfolgreich verarbeitet.',
        initializing: 'Zahlungsformular wird initialisiert...',
        initializingPaymentForm: 'Zahlungsformular wird initialisiert...',
        stripeInitializationFailed: 'Fehler beim Initialisieren des Zahlungsformulars',
    },
    dialogs: {
        maintenance: {
            title: 'Es finden derzeit Wartungsarbeiten statt',
            message:
                'Ihre Aktion konnte nicht ausgeführt werden. Bitte entschuldigen Sie die Unannehmlichkeiten. Die Seite wird automatisch neu geladen, wenn die Wartungsarbeiten abgeschlossen sind.',
            countdown: 'Nächster Versuch in {counter} Sekunden.',
        },
        sessionExpiration: {
            title: 'Ihre Sitzung ist abgelaufen',
            message: 'Bitte melden Sie sich erneut an.',
        },
        confirmation: {
            title: 'Sind Sie sich sicher?',
            message: 'Möchten Sie wirklich fortfahren?',
            destroyEntryMessage: 'Möchten Sie diesen Eintrag wirklich löschen?',
        },
        feedback: {
            title: 'Wie können wir unseren Service verbessern?',
        },
        confirmPassword: {
            title: 'Bestätigen Sie Ihr Passwort',
            toast: 'Passwort erfolgreich bestätigt',
        },
        doNotShowAgain: 'Diese Meldung nicht mehr anzeigen',
    },
    globalMessages: {
        serverError: {
            message: 'Etwas ist schief gelaufen!',
            description:
                'Bitte versuchen Sie es später noch einmal oder kontaktieren Sie gerne unseren Support.',
        },
        configuratorMaintenance: {
            message: 'Wartungsarbeiten',
            description:
                'Es finden derzeit Wartungsarbeiten am Konfigurator statt. Dieser steht Ihnen in Kürze wieder zur Verfügung.',
        },
        insufficientPermissions: {
            message: 'Unzureichende Berechtigungen',
            description:
                'Sie wurden auf das Dashboard umgeleitet, da Sie nicht über die erforderlichen Berechtigungen verfügen.',
        },
        ticketNotFound: {
            message: 'Ticket nicht gefunden.',
            description:
                'Das Ticket wurde möglicherweise gelöscht oder Sie haben keinen Zugriff. Sie wurden zur Ticketliste weitergeleitet.',
        },
        unconfirmedPassword: {
            message: 'Password wurde nicht bestätigt!',
        },
        notFound: {
            message: 'Seite oder Ressource nicht gefunden!',
            description:
                'Möglicherweise wurde die Adresse falsch eingegeben, die Seite wurde verschoben oder ist nicht mehr verfügbar.<br /> Wenn Sie Fragen haben, wenden Sie sich gerne an <a href="#" class="underline cursor-pointer">unseren Support</a>.',
        },
        maintenance: {
            message: 'Es finden derzeit Wartungsarbeiten statt',
            description:
                'Diese Seite steht Ihnen in Kürze wieder zur Verfügung. Bitte versuchen Sie es später noch einmal oder wenden Sie sich gerne an <a href="#" class="underline cursor-pointer">unseren Support</a>.',
        },
    },
    validations: {
        required: 'Dies ist ein Pflichtfeld',
        requiredIf: 'Dies ist ein Pflichtfeld',
        minLength: 'Mindestens {min} Zeichen',
        email: 'Die eingegebene Mail-Adresse ist ungültig',
        ipV4: 'Die eingegebene IPv4-Adresse ist ungültig',
        between: 'Bitte geben Sie einen Wert zwischen {min} und {max} ein',
        sameAs: 'Muss mit "{otherName}" übereinstimmen',
        fileSize50: 'Die Datei darf maximal 50 MB groß sein',
        allowedAttachmentType:
            'Mindestens ein Anhang hat einen ungültigen Dateityp. Erlaubte Formate: PDF, JPG, PNG, GIF, WebP, TXT, CSV, DOC, DOCX, XLS, XLSX.',
        mustBeConfirmed: 'Dieses Feld muss bestätigt werden',
        endTimeTooEarly:
            'Bitte prüfen Sie Ihre Zeitangaben. Das Ende Ihres Besuchs liegt aktuell vor dem angegebenen Ankunftszeitpunkt.',
        endDateInPast:
            'Bitte prüfen Sie Ihre Datumsangaben. Das gewählte Enddatum liegt in der Vergangenheit. Bitte wählen Sie ein zukünftiges Datum.',
        visitTooShort:
            'Bitte prüfen Sie Ihre Zeitangaben. Für einen Besuch in unserem Rechenzentrum sollten Sie mindestens eine Stunde einplanen.',
        startTimeInPast:
            'Die gewählte Startzeit liegt in der Vergangenheit. Bitte wählen Sie eine Uhrzeit ab {minTime} Uhr.',
    },
    links: {
        privacy: 'Datenschutz',
        imprint: 'Impressum',
        dedicatedServer: 'Dedicated Server',
        colocation: 'Colocation',
        cloudServer: 'Cloud Server',
        s3Storage: 'S3-Storage',
    },
};
